import { Grid, Link, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import React from 'react';
import { useTranslation } from 'react-i18next';

const HomeHelpStyle = makeStyles({
  boxDimensions: {
    height: 100,
    width: '100%',
    padding: 15,
  },
  titleSettings: {
    fontSize: 16,
    fontWeight: 500,
    letterSpacing: 0,
    lineHeight: '20px',
    alignSelf: 'center',
    marginLeft: 8,
  },
  marginSpace: {
    marginBottom: 10,
  },
  linkPurpleColor: {
    color: '#8067E5',
    textDecoration: 'none',
    cursor: 'pointer',
  },
});

const HomeHelp = () => {
  const classes = HomeHelpStyle();
  const { t } = useTranslation('common');

  return (
    <Grid container={true} className={classes.boxDimensions} direction="column">
      <Grid item={true} className={classes.marginSpace}>
        <Typography className={classes.titleSettings}>{t('info')}</Typography>
      </Grid>
      <Grid item={true}>
        <a href="http://soporte.wholemeaning.com/support/home">
          <Typography className={`${classes.titleSettings} ${classes.linkPurpleColor}`}>
            {t('helpcenter')}
          </Typography>
        </a>
      </Grid>
    </Grid>
  );
};

export default HomeHelp;
